module.exports = __webpack_public_path__ + "img/mktzap.4ad5ed6f.svg";